import { useMutation } from '@/react-query/hooks/useMutation/useMutation';
import { revalidate } from '@/services/revalidate/revalidate';
import { useQueryClient } from '@tanstack/react-query';
import { toast } from 'sonner';

const useUpdateCustomerPaymentLogs = () => {
  const queryClient = useQueryClient();
  const { mutateAsync: mutateAsyncCustomerPaymentLogs, isPending } = useMutation('updateCustomerPaymentLogs', {
    onSuccess: async (res) => {
      await queryClient.invalidateQueries({ queryKey: ['customer-payment-logs'] });
      await revalidate(['all', 'totalReferralPoint', 'refers', 'points']);
      toast.success(res.message);
    },
    onError: (error) => {
      toast.error(error.message);
    },
  });

  return { mutateAsyncCustomerPaymentLogs, isPending };
};

export default useUpdateCustomerPaymentLogs;
